"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyGridList = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const StyledGridContainer = (0, material_1.styled)("div")({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-around",
  overflow: "hidden"
});
const StyledGrid = (0, material_1.styled)(material_1.Grid, {
  shouldForwardProp: prop => prop !== "gridListHeight"
})(({
  gridListHeight
}) => ({
  width: 975,
  height: gridListHeight || 450
}));

const SskyGridList = props => {
  return react_1.default.createElement(StyledGridContainer, {
    className: (0, classnames_1.default)("SskyGridList", props.className),
    "data-testid": props.dataTestId || `testId-dialog-${props.id}`
  }, react_1.default.createElement(StyledGrid, {
    container: true,
    gridListHeight: props.gridListHeight
  }, props.tiles.map(tile => react_1.default.createElement(material_1.Grid, {
    item: true,
    key: tile.id
  }, tile.content))));
};

exports.SskyGridList = SskyGridList;
exports.default = react_1.default.memo(SskyGridList);